import { MinpakuTourPageFlatSample } from "./minpaku-tour-page-flat-sample";
import { MinpakuTourPageNestSample } from "./minpaku-tour-page-nest-sample";

const isNestSample = true;

export const MinpakuTourPage = () => {
  if (isNestSample) {
    return <MinpakuTourPageNestSample />;
  }
  return <MinpakuTourPageFlatSample />;
};
